import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Lightbox from './Lightbox'; 
import config from '../config/config';

const UserChatGallery = ({ receiverId }) => {
  const [mediaGallery, setMediaGallery] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  useEffect(() => {
    const fetchMediaGallery = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.get(`${config.baseURL}/get-gallery`, {
          params: { receiver_id: receiverId },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.success) {
          setMediaGallery(response.data.media_gallery);
        } else {
          console.error('Failed to fetch media gallery:', response.data.error);
        }
      } catch (error) {
        console.error('Error fetching media gallery:', error);
      }
    };

    fetchMediaGallery();
  }, [receiverId]);

  const openLightbox = (index) => {
    setCurrentIndex(index);
     document.body.classList.add('modal-open-message_lightbox_gallery');
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    document.body.classList.remove('modal-open-message_lightbox_gallery');
    setLightboxOpen(false);
  };
  

  return (
    <div className="media_gallery">
      {mediaGallery.length > 0 ? (
        mediaGallery.map((media, index) => (
          <div key={media.media_id} className="media_item" onClick={() => openLightbox(index)}>
            {media.file_type === 'image' ? (
              <img src={media.url} alt={media.name} className="media_image" />
            ) : media.file_type === 'video' ? (
              <video controls className="media_video">
                <source src={media.url} type="video/mp4" />
              </video>
            ) : null}
          </div>
        ))
      ) : (
        <p className="no_list">No media available.</p>
      )}
      {lightboxOpen && (
        <Lightbox media={mediaGallery} onClose={closeLightbox} currentIndex={currentIndex} />
      )}
    </div>
  );
};

export default UserChatGallery;
